export const initialState = {
  values: {
    transactionId: "",
    category: "",
    agriSector: "",
    city: "",
    state: "",
    country: "",
    currency: "",
    orderQty: '',
    area: '',
    nutrientValue: '',
    moistureValue: '',
    weightSize: '',
    measureUnit: '',
    purchasedFrom: '',
    purchasedDate: '',
    expectedYield: '',
    harvestDate: '',
    gradedBy: '',
    gradedDate: '',
    secondGrader: '',
    description: '',
    harvestImage: '',

  },
  errors: {
    transactionId: "",
    category: "",
    agriSector: "",
    city: "",
    state: "",
    country: "",
    currency: "",
    orderQty: '',
    area: '',
    nutrientValue: '',
    moistureValue: '',
    weightSize: '',
    measureUnit: '',
    purchasedFrom: '',
    purchasedDate: '',
    expectedYield: '',
    harvestDate: '',
    gradedBy: '',
    gradedDate: '',
    secondGrader: '',
    description: '',
    harvestImage: '',
  },
}
